import { createTheme } from '@mui/material/styles';

import breakpoints from 'utils/breakpoints';
import { getColor } from 'utils/colors';
import mixins from 'utils/mixins';
import { remCalc } from 'utils/remCalc';

const theme = createTheme({
	breakpoints: breakpoints,
	mixins: mixins,
});

export const overrides = {
	'.threeCardLayout__section': {
		margin: '100px auto',
		'.threeCardLayout__title_row': {
			marginBottom: '40px',
			'.threeCardLayout__title_wrap': {
				display: 'flex',
				alignItems: 'center',
				'.threeCardLayout__title': {
					textTransform: 'uppercase',
				},
				[theme.breakpoints.down('md')]: {
					justifyContent: 'center',
				},
			},
			'.threeCardLayout__subtitle_wrap': {
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'flex-end',
				'.threeCardLayout__subtitle': {
					fontStyle: 'italic',
				},
				[theme.breakpoints.down('md')]: {
					justifyContent: 'center',
				},
			}
		},
		'.threeCardLayout__cards_row': {
			'&.threeCardLayout__cards_row-length-1': {
				'.threeCardLayout__card': {
					aspectRatio: '16 / 9',
					[theme.breakpoints.up('xl')]: {
						aspectRatio: '2.5 / 1',
					},
				},
			},
			'&.threeCardLayout__cards_row-length-2': {
				'.threeCardLayout__card': {
					aspectRatio: '50 / 50',
				},
			},
			'&.threeCardLayout__cards_row-length-3': {
				'.threeCardLayout__card': {
					[theme.breakpoints.up('sm')]: {
						aspectRatio: '3.26 / 1',
					},
					[theme.breakpoints.up('ms')]: {
						aspectRatio: '1.66 / 1',
					},
					[theme.breakpoints.up('md')]: {
						aspectRatio: '13 / 23',
					},
				},
			},
			'.threeCardLayout__card': {
				backgroundColor: getColor('blue', 100),
				backgroundPosition: 'center',
				backgroundSize: 'cover',
				backgroundRepeat: 'no-repeat',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				padding: '96px 40px',
				textAlign: 'center',
				position: 'relative',
				[theme.breakpoints.up('sm')]: {
					aspectRatio: '3.26 / 1',
				},
				[theme.breakpoints.up('ms')]: {
					aspectRatio: '1.66 / 1',
				},
				[theme.breakpoints.up('md')]: {
					aspectRatio: '13 / 23',
				},
				'.threeCardLayout__card_mask': {
					background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.65) 0%, rgba(0, 0, 0, 0.65) 100%)',
					position: 'absolute',
					width: '100%',
					height: '100%',
					left: 0,
					top: 0,
					opacity: 0,
					transition: 'all .6s ease-in-out',
				},
				'.threeCardLayout__card_title': {
					color: getColor('white', 100),
					zIndex: 1
				},
				'.threeCardLayout__card_cta': {
					position: 'absolute',
					color: getColor('white', 100),
					zIndex: 1,
					textTransform: 'uppercase',
					textAlign: 'center',
					fontFamily: 'var(--heading-font)',
					fontSize: remCalc('20px'),
					fontStyle: 'normal',
					fontWeight: 420,
					lineHeight: remCalc('24px'),
					letterSpacing: remCalc('2px'),
					bottom: remCalc('65px'),
					opacity: 0,
					transition: 'all .5s ease-in-out',
					display: 'inline-flex',
					alignItems: 'center',
					justifyContent: 'center',
					flexDirection: 'column',
					[theme.breakpoints.up('md')]: {
						bottom: remCalc('125px'),
					},
					'&:after': {
						content: '""',
						display: 'block',
						width: '100%',
						height: remCalc('1px'),
						backgroundColor: getColor('white', 100),
						marginTop: remCalc('5px'),
					}
				},
				'.threeCardLayout__card_link': {
					position: 'absolute',
					width: '100%',
					height: '100%',
					left: '0',
					top: '0',
					zIndex: '2',
				},
				'&.has_link': {
					[theme.breakpoints.down('md')]: {
						'.threeCardLayout__card_mask': {
							opacity: .7,
						},
						'.threeCardLayout__card_cta': {
							opacity: 1,
						}
					},
					[theme.breakpoints.up('md')]: {
						'&:hover': {
							'.threeCardLayout__card_mask': {
								opacity: 1,
							},
							'.threeCardLayout__card_cta': {
								opacity: 1,
							}
						}
					}
				}
			}
		}
	}
}

const styles = {};

export default styles;